import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { Status, STATUS_SIZE_20 } from '../../../Status'
import Text from '../../../Text'

import * as styles from '../RentalPortalViewingApplicantPreviewModal.module.css'

function ViewingApplicantPreviewSection({ section }) {
  const { t } = useTranslation()

  return (
    <div className={styles.section}>
      <Text className={styles.sectionTitle}>{section.title}</Text>
      {section.rows.length > 0 ? (
        <div className={styles.rows}>
          {section.rows.map(row => (
            <Fragment key={row.key}>
              <Text isSecondary className={styles.rowLabel}>
                {row.label}
              </Text>
              {row.statusProps ? (
                <Status
                  {...row.statusProps}
                  className={styles.rowStatus}
                  height={STATUS_SIZE_20}
                />
              ) : (
                <Text className={styles.rowValue}>{row.text}</Text>
              )}
            </Fragment>
          ))}
        </div>
      ) : (
        <Text isSecondary>{t('Select.NoDataKey')}</Text>
      )}
    </div>
  )
}

export default ViewingApplicantPreviewSection
